<template>
  <div>
    <div class="eventInformation">
      <v-container class="pt-0">
        <v-layout row wrap>
          <v-flex sm7 class="information">
            <h4 v-if="extract('event.open')">Register for the</h4>
            <h3
              v-html="
                extract('event.content.body.title') || extract('event.name')
              "
            ></h3>
            <!-- <h4>BUILDING CONNECTIONS. FOSTERING EXCELLENCE.</h4> -->
            <!-- <h4 class="mb-3"><em>Leveraging the Network to Amplify Success</em></h4> -->
            <div
              class="event-description mr-4"
              v-html="extract('event.content.body.description')"
            ></div>

            <v-container fluid class="mx-0 px-0 py-0 my-0 mb-4">
              <v-layout row wrap>
                <v-flex xs12>
                  <h4 class="text-black">
                    <strong v-if="false">Explore These Additional Opportunities!</strong>
                    <strong>New this year!</strong>
                  </h4>
                  <ul class="list-unstyled pl-0">
                  <li class="my-3">
                      <h5 class="my-1"><a href="https://amaze.rti.org/event/pre-conference-study-visit-2024" alt="Learn more about the Pre-Summit Early College Study Visits" target="_blank" rel="noopener">Pre-Summit Early College Study Visits on <span class=" text-nowrap text-no-wrap">Monday  June 3<sup>rd</sup></span></a></h5></li>
                  </ul>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card>
              <v-container fluid class="mb-4">
                <v-layout class="mx-0 px-0 my-0">
                  <v-col
                    ><h4 class="title mainTitle mb-2">
                      Featured Keynote Speaker
                    </h4></v-col
                  >
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs12 lg5
                    ><div class="name">
                      <h4 class="mb-2">
                        <a
                          href="https://georgecouros.ca/blog/"
                          target="_blank"
                          rel="noopener"
                          >George Couros</a
                        >
                      </h4>
                    </div>
                    <div class="photo">
                      <a
                        href="https://georgecouros.ca/blog/"
                        target="_blank"
                        rel="noopener"
                        ><img
                          src="https://amaze-assets.s3.us-west-1.amazonaws.com/files/events/2024_Early_College_Summit/Goerge+Couros+2024.jpg"
                          style="max-height: 450px; max-width: 90%"
                      /></a></div
                  ></v-flex>
                  <v-flex xs11 sm9 lg6 mt-4>
                    <div class="mt-2">
                      George Couros is an International leader and speaker on
                      innovative teaching, learning, and leading, and the author
                      of
                      <i
                        >The Innovator’s Mindset: Empower Learning, Unleash
                        Talent, and Lead a Culture of Creativity</i
                      >, <i>Innovate Inside the Box</i>, and
                      <i>Because of a Teacher</i> and
                      <i>Because of a Teacher 2</i>. George’s keynote will focus
                      on how our ever-changing world presents incredible
                      challenges that also reveal opportunities to innovate to
                      support student success. George will highlight ideas from
                      <a
                        href="https://www.amazon.com/The-Innovators-Mindset-Learning-Creativity/dp/0986155497/ref=cm_cr_arp_d_product_top?ie=UTF8"
                        target="_blank"
                        rel="noopener"
                        >“The Innovator’s Mindset”</a
                      >
                      and
                      <a
                        href="https://www.novakeducation.com/iitb"
                        target="_blank"
                        rel="noopener"
                        >“Innovate Inside the Box”</a
                      >
                      as he challenges and inspires summit attendees to create
                      incredible learning opportunities that support the success
                      of all students.
                      <br /><br /><a
                        href="https://georgecouros.ca/blog/"
                        target="_blank"
                        rel="noopener"
                        >Learn more about George Couros</a
                      >
                    </div></v-flex
                  >
                </v-layout>
              </v-container>
            </v-card>

            <table
              class="event-sections"
              v-if="extract('event.content.body.sections')"
            >
              <tr
                v-for="(obj, num) in extract('event.content.body.sections')"
                v-bind:key="num"
              >
                <td class="rowLabel">
                  <h4 class="section-title">
                    {{
                      extract('event.content.body.sections.' + num + '.title')
                    }}:
                  </h4>
                </td>
                <td
                  v-html="
                    extract('event.content.body.sections.' + num + '.html')
                  "
                ></td>
              </tr>
            </table>
            <div
              class="event-closing"
              v-if="extract('event.content.body.closing')"
            >
              <AmazeDynamicComponent
                v-bind:template="extract('event.content.body.closing')"
              ></AmazeDynamicComponent>
            </div>

            <div>
              <span
                class="capacity-notice"
                v-if="!loading && availableSlots < 1"
                >The event is currently at capacity, but sign up below to be
                added to the wait list and we'll email you if a spot opens
                up.</span
              >
            </div>
          </v-flex>
          <v-flex sm4 xl3 offset-sm1 hidden-xs-only class="callout">
            <!-- IF DEFAULT ASIDE -->
            <div class="whiteBox pa-4" v-if="hasAside">
              <div v-if="defaultAside">
                <p>
                  <v-img src="@/assets/es/Summit_01@2x.jpg" />
                </p>
                <p>
                  <v-img src="@/assets/es/Summit_02@2x.jpg" />
                </p>
              </div>
              <div v-else class="customAside">
                <AmazeDynamicComponent
                  v-bind:template="extract('event.content.aside.html')"
                ></AmazeDynamicComponent>
              </div>
            </div>
            <!-- END DEFAULT ASIDE -->
            <div id="refund-dialog">
              <v-dialog v-model="dialog" max-width="500px">
                <v-btn
                  slot="activator"
                  color="primary"
                  style="display: none"
                  id="refund-dialog-button"
                  class="mb-4 mt-4 ml-0"
                >
                  Learn more about RTI's refund and cancellation policy
                </v-btn>
                <v-card>
                  <v-card-title>
                    <h3 class="headline">Refund and Cancellation Policy</h3>
                  </v-card-title>
                  <hr class="thick" />

                  <v-card-text>
                    <v-layout wrap>
                      <div class="pa-2 mb-2">
                        <p>
                          The {{ event.name }} Cancellation and Refund Policy
                          will be as follows to assure consistency and is
                          applicable to this event.
                        </p>
                        <p>
                          {{ event.name }} registration canceled online on or
                          before {{ getFormattedDate(event.refund_expiry) }} is
                          refundable if already paid, or not due if not already
                          paid. In order for your cancellation to be received,
                          email
                          <a href="mailto:educationservices@rti.org "
                            >educationservices@rti.org</a
                          >
                          no later than
                          {{ getFormattedDate(event.refund_expiry) }}.
                        </p>
                      </div>
                    </v-layout>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer />
                    <v-btn color="blue darken-1" flat @click="dialog = false"
                      >Cancel</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </div>

    <!-- BEGIN THE FORMATIONING -->
    <div class="registrationForm" v-if="!loading">
      <div class="text-xs-center" v-if="!extract('event.open')">
        <h4>Registration is closed for this event.</h4>
      </div>
      <v-form
        ref="regForm"
        v-model="valid"
        v-if="
          !this.extract('event.content.form.custom') && extract('event.open')
        "
      >
        <v-container>
          <v-layout>
            <v-flex md6>
              <h3>
                Registration
                <small>Required fields <span class="star">*</span></small>
              </h3>

              <h5 v-if="!registrationIsSingle">
                School &amp; Team Information
              </h5>

              <v-text-field v-model="schoolName" required :rules="rules.school">
                <template slot="label"
                  >School Name<span class="star">*</span></template
                >
              </v-text-field>

              <v-text-field
                v-model="districtName"
                required
                :rules="rules.district"
              >
                <template slot="label"
                  >District Name<span class="star">*</span></template
                >
              </v-text-field>

              <v-text-field v-model="stateName" required :rules="rules.state">
                <template slot="label"
                  >State<span class="star">*</span></template
                >
              </v-text-field>

              <p>
                <strong
                  >Is your school a member of the RTI Early College
                  Network?<span class="star">*</span></strong
                >
              </p>
              <v-radio-group
                v-model="earlyCollegeNetwork"
                required
                :rules="rules.earlyCollegeNetwork"
              >
                <v-radio
                  v-for="n in earlyCollegeNetworkOptions"
                  :key="n.value"
                  :label="n.text"
                  :value="n.value"
                  required
                ></v-radio>
              </v-radio-group>

              <p>
                <strong
                  >Please identify any specific topic areas you would like to
                  learn more about at the Summit this year.</strong
                >
              </p>
              <v-textarea
                outline
                v-model="topics"
                :rules="rules.topics"
                rows="2"
              ></v-textarea>

              <p><strong>Please list any dietary restrictions.</strong></p>
              <v-textarea
                outline
                v-model="diet"
                :rules="rules.diet"
                rows="2"
              ></v-textarea>

              <div v-if="maxRegistrants > 1">
                <p>
                  <strong
                    >Size of school team (total registrants)<span class="star"
                      >*</span
                    ></strong
                  >
                </p>
                <p>
                  After selecting the size of your team, you will be able to
                  enter attendee information
                </p>
                <v-select
                  :items="registrantSlots"
                  label="Select Size"
                  v-model="registrants"
                  required
                  :rules="rules.size"
                  @change="initializeSlots"
                ></v-select>

                <div v-if="registrants > 0">
                  <h5>Attendee Information</h5>
                  <p>
                    Please enter the registration information (name, email and
                    role) for each person on your school team.
                    <strong>Registrant 1</strong> will receive email
                    confirmation and payment information.
                  </p>

                  <template v-for="(obj, num) in registrant">
                    <div class="registrant" :key="num">
                      <h6>Registrant {{ num + 1 }}</h6>
                      <v-text-field
                        v-model="registrant[num].name"
                        required
                        :rules="rules.name"
                      >
                        <template slot="label">
                          Registrant {{ num + 1 }}: Name<span class="star"
                            >*</span
                          >
                        </template>
                      </v-text-field>
                      <AmazeEmailAddressInput v-model="registrant[num].email">
                        <template slot="label"
                          >Registrant {{ num + 1 }}: E-mail</template
                        >
                      </AmazeEmailAddressInput>

                      <AmazeSelectThenOther
                        :items="roles"
                        :condition="'Other'"
                        :required="true"
                        v-model="registrant[num].role"
                      >
                        <template slot="label"
                          >Registrant {{ num + 1 }}: Role</template
                        >
                        <template slot="labelOther"
                          >Please specify the role</template
                        >
                      </AmazeSelectThenOther>
                    </div>
                  </template>
                </div>
              </div>
              <div v-if="maxRegistrants == 1">
                <v-text-field
                  v-model="registrant[0].name"
                  required
                  :rules="rules.name"
                >
                  <template slot="label">
                    Name<span class="star">*</span>
                  </template>
                </v-text-field>
                <AmazeEmailAddressInput v-model="registrant[0].email">
                  <template slot="label">E-mail</template>
                </AmazeEmailAddressInput>
                <AmazeSelectThenOther
                  :items="roles"
                  :condition="'Other'"
                  :required="true"
                  v-model="registrant[0].role"
                >
                  <template slot="label">Role</template>
                  <template slot="labelOther">Please specify the role</template>
                </AmazeSelectThenOther>
              </div>

              <div class="submit-wrapper" v-if="registrants > 0">
                <div class="submit-success" v-if="this.submittedSuccessfully">
                  <h5>Success!</h5>
                  <p>
                    <strong
                      >Thank you for registering for the
                      {{
                        extract('event.content.body.title') ||
                        extract('event.name')
                      }}!</strong
                    >
                    You should receive a confirmation email shortly. If you do
                    not receive an email, please contact
                    <a :href="'mailto:' + contactAddress">{{
                      contactAddress
                    }}</a
                    >.
                  </p>
                </div>
                <div class="submit-incomplete" v-else>
                  <h5>Complete Registration</h5>
                  <div v-if="!registrationIsSingle">
                    <p>
                      After submitting this form,
                      <strong>Registrant 1</strong> will receive an email
                      confirming your school’s registration, total fees owed
                      based on number of participants, and instructions on
                      sending in payment.
                    </p>
                    <p>
                      <strong>Please note:</strong> all team members will
                      receive an email with a personalized link to review and
                      accept terms and conditions.
                      <a
                        href="https://amaze-assets.s3.us-west-1.amazonaws.com/files/events/2024_Early_College_Summit/Waiver%2Band%2BRelease%2BForm%2BECS%2B2024.pdf"
                        target="_blank"
                        title="Early College Summit 2022 Terms and Conditions"
                        >The terms and conditions</a
                      >
                      must be accepted prior to the event.
                    </p>
                  </div>
                  <div v-if="registrationIsSingle">
                    <p>
                      After submitting this form, you will be prompted to review
                      our terms and conditions to finalize your registration.
                      You will also receive a confirmation email with your
                      registration details.
                    </p>
                  </div>
                  <v-btn
                    v-if="!submitted"
                    class="ml-0"
                    color="primary"
                    @click="submitRegistration()"
                    >Submit Registration</v-btn
                  >
                  <v-progress-circular v-else indeterminate />
                </div>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </div>

    <!-- END THE FORMATIONING -->
  </div>
</template>

<style lang="scss" scoped>
@import 'src/styles/variables.scss';

#EducationServicesTemplate {
  .submit-wrapper {
    /* The default is -40px. But for some reason that doesn't work with this template so whatever. */
    margin-top: 0px;
  }
}
</style>

<script>
import registrationMixin from '@/mixins/registrationMixin.js'

export default {
  mixins: [registrationMixin],
  data () {
    return {
      dialog: false,
      loading: true,
      valid: false,
      submitted: false,

      availableSlots: 0,
      maxRegistrants: 0,
      totalAttendees: 0,

      diet: '',
      topics: '',

      schoolName: '',
      districtName: '',
      stateName: '',
      roles: ['Principal', 'Teacher', 'Counselor', 'College Liaison', 'Other'],

      earlyCollegeNetwork: null,
      earlyCollegeNetworkOptions: [
        { text: 'Yes', value: 1 },
        { text: 'No', value: 0 }
      ],

      registrants: 0,
      numRegistrants: 0,
      registrant: [],
      submittedSuccessfully: false,
      rules: {
        name: [v => !!v || 'Name is required.'],
        email: [
          v => !!v || 'Email is required.',
          v => /@/.test(v) || 'Please enter a valid email.'
        ],
        role: [v => !!v || 'Role is required.'],
        school: [v => !!v || 'School name is required.'],
        district: [v => !!v || 'District name is required.'],
        state: [v => !!v || 'State is required.'],
        size: [v => !!v || 'Team size is required.'],
        date: [v => !!v || 'Date is required.'],
        diet: [
          v =>
            (v || '').length <= 200 ||
            'Description must be 200 characters or less'
        ],
        topics: [
          v =>
            (v || '').length <= 200 ||
            'Description must be 200 characters or less'
        ],
        earlyCollegeNetwork: [
          v =>
            v === 0 ||
            v === 1 ||
            'Please specify if your school is part of the Early College Network.'
        ]
      },
      event: {}
    }
  },
  computed: {
    content () {
      //                var defaults = {};
      return event.content ? event.content : false
    },
    id () {
      return this.extract('event.id')
    },
    hasAside () {
      var aside = this.extract('event.content.aside.custom')
      return aside !== null
    },
    defaultAside () {
      return (
        !this.extract('event.content.aside.custom') ||
        !this.extract('event.content.aside.html')
      )
    },
    registrationIsSingle () {
      return this.maxRegistrants === 1
    },
    registrantSlots () {
      let slots = []
      for (let i = 1; i <= this.maxRegistrants; i++) {
        if (i === 1) {
          slots.push({ text: i + ' attendee', value: i })
        } else {
          slots.push({ text: i + ' attendees', value: i })
        }
      }
      return slots
    },
    contactAddress () {
      return process.env.VUE_APP_CONTACT_ADDRESS
    },
    loaded () {
      return !this.loading
    },
    showSubmitPrompt () {
      return !this.submittedSuccessfully && this.registrants > 0
    }
  },
  methods: {
    initializeSlots () {
      let backup = this.registrant
      this.registrant = []
      for (let person = 0; person < this.registrants; person++) {
        if (backup[person]) {
          this.registrant[person] = backup[person]
        } else {
          this.registrant[person] = {
            name: '',
            email: null,
            role: null
          }
        }
      }
    },
    submitRegistration () {
      if (this.$refs.regForm.validate()) {
        this.submitted = true
        let data = {
          school: this.schoolName,
          district: this.districtName,
          state: this.stateName,
          team_total: this.registrants,
          registration_event_id: this.extract('event.id'),
          registration_team_member: this.registrant,
          single_registration: this.registrationIsSingle,
          early_college_network: this.earlyCollegeNetwork,
          extra_attributes: {
            'Dietary Needs': '',
            'Topic Areas': ''
          }
        }

        data['extra_attributes']['Dietary Needs'] = this.diet
        data['extra_attributes']['Topic Areas'] = this.topics

        this.$http.post('registrations', data).then(
          response => {
            this.$router.push({
              path:
                '/event/terms/' +
                response.body.data.registration_team_member[0].uuid
            })
            this.$store.commit('updateMessage', {
              message:
                'Please review the terms and conditions to complete registration.',
              snackbar: true
            })
          },
          response => {
            this.submitted = false
            this.$store.commit('updateMessage', {
              message:
                'There was a problem saving your registration. Please try again or contact support.',
              snackbar: true
            })
          }
        )
      } else {
        this.$store.commit('updateMessage', {
          message: 'Required fields are missing. Please review the form.',
          snackbar: true
        })
      }
    }
  },
  mounted () {
    this.$http
      .get(
        'event/' +
          (this.$route.params.slug || this.$route.path.split('/').pop())
      )
      .then(
        response => {
          this.event = response.data.data[0]

          this.totalAttendees = this.extract('event.total_attendees') || 0
          this.maxAttendees = this.extract('event.max_attendees') || 0

          this.availableSlots = Math.max(
            0,
            this.maxAttendees - this.totalAttendees
          )

          this.maxRegistrants = this.extract('event.max_per_team')
          // If we need to limit registration to only accept the max number of slots, we can use the following logic:
          // Math.min(this.extract('event.max_per_team'), (this.maxAttendees - this.totalAttendees));

          if (this.maxRegistrants === 1) {
            // Single registration, set-up initial object to avoid null object errors.
            this.registrant.push({ name: '', email: null, role: null })
            this.registrants = 1
          }

          this.loading = false
          // eslint-disable-next-line handle-callback-err
        },
        error => {
          this.$router.push('/404')
        }
      )
  }
}
</script>
